<mat-expansion-panel [expanded]="true" class="print-element" [ngClass]="{ 'mobile-view': mobileView }">
  <ngx-loading [show]="isLoading"></ngx-loading>
  <div class="service-chart-color"></div>
  <mat-expansion-panel-header
    [collapsedHeight]="'auto'"
    [expandedHeight]="'auto'"
    [ngClass]="{ 'p-0': mobileView }"
    #panelHeader
    (click)="panelHeader._toggle()"
  >
    <mat-panel-title [ngClass]="{ 'w-100': mobileView }">
      <div class="d-flex flex-column panel-box px-3 pt-2 pb-2">
        <!-- Appointment Template -->
        <ng-container>
          <!-- Header row of sc entry -->
          <div class="row align-items-center mb-2 mx-0">
            <div class="col-3 align-items-center pl-0 pr-1">
              <span *ngIf="chartEntry" class="font-weight-normal medium">
                {{ chartEntry?.date | date : 'yyyy-MM-dd h:mm a' }}
              </span>
            </div>
            <div class="entry-buttons col-4 d-flex justify-content-end align-items-center pr-0 ml-auto fit-content">
              <ng-container *ngIf="chartEntry">
                <ng-container *appAuthGuard="patientChartEditPolicy">
                  <ng-container *ngIf="!isRecordingConsultation && !isRecordingDictation; else stopRecordingButton">
                    <kendo-dropdownbutton
                      iconClass="fas fa-microphone "
                      [data]="audioMenuData"
                      title="Record Audio"
                      [disabled]="chartEntry?.isLocked"
                      [buttonClass]="[
                        'btn',
                        'btn-sm',
                        'em-btn',
                        'em-btn-teal',
                        'btn-clean',
                        'mr-2',
                        'chart-entry-button',
                        'k-btn-microphone'
                      ]"
                      (itemClick)="startRecording($event)"
                    >
                    </kendo-dropdownbutton>
                  </ng-container>
                </ng-container>
                <ng-template #stopRecordingButton>
                  <button
                    title="Stop Recording"
                    type="button"
                    class="btn btn-sm em-btn em-btn-red btn-clean mr-2 chart-entry-button"
                    (click)="stopRecording()"
                  >
                    <i style="font-size: 16px" class="fas fa-circle"></i>
                  </button>
                </ng-template>

                <button
                  [title]="showServiceDetail ? 'Collapse Text' : 'Expand Text'"
                  [disabled]="getParentNoteComponentHeight() <= 64"
                  type="button"
                  class="btn btn-sm em-btn em-btn-green btn-clean mr-2 bigger chart-entry-button"
                  (click)="showServiceDetail = !showServiceDetail; toggleTextArea()"
                >
                  <i style="font-size: 18px" [class]="showServiceDetail ? 'fas fa-caret-up' : 'fas fa-caret-down'"></i>
                </button>

                <ng-container *appAuthGuard="patientChartEditPolicy">
                  <button
                    *ngIf="!mobileView"
                    [title]="!chartEntry?.isLocked ? 'Delete Entry' : 'Note Locked - Cannot Delete'"
                    [disabled]="chartEntry?.isLocked"
                    type="button"
                    class="btn btn-sm em-btn em-btn-green btn-clean mr-2 bigger chart-entry-button"
                    (click)="deleteNote()"
                  >
                    <i class="far fa-trash-alt"></i>
                  </button>
                </ng-container>

                <button
                  title="Entry Unlocked"
                  *ngIf="!chartEntry?.isLocked"
                  [disabled]="true"
                  type="button"
                  class="btn btn-sm em-btn em-btn-green btn-clean bigger chart-entry-button lock-btn"
                >
                  <i class="far fa-lock" title="Entry Unlocked"></i>
                </button>

                <button
                  title="Unlock Entry"
                  *ngIf="chartEntry?.isLocked"
                  [disabled]="!patientChartEditPolicySatisfied"
                  (click)="onUnlockClick()"
                  type="button"
                  [attr.data-test-id]="'service-chart-unlock'"
                  [attr.data-test-value]="chartEntry?.patientNoteId"
                  class="btn btn-sm em-btn em-btn-green btn-clean bigger chart-entry-button lock-btn"
                >
                  <i class="fas fa-unlock text-dark" title="Entry Locked"></i>
                </button>
              </ng-container>
            </div>
          </div>

          <!-- Main text area for sc entry -->
          <div class="d-flex flex-wrap negative-right-margin">
            <div
              class="d-flex align-items-center flex-column flex-grow-1 font-weight-normal mr-2 mb-2 medium textarea-wrapper"
              (click)="onTextareaFocus()"
            >
              <div class="w-100" #noteParent>
                <ng-container *ngIf="isHtml(chartEntry?.entryText); else textAreaContent">
                  <div
                    class="service-chart-input px-2 mx-2 w-100"
                    [ngClass]="{
                      'collapsed-area': !showServiceDetail,
                      'mask-fade pointer-cursor': !showServiceDetail && getHtmlComponentHeight() > 64,
                      'd-none': !chartEntry?.entryText
                    }"
                    [innerHTML]="chartEntry?.entryText"
                    #existingNoteHtml
                  ></div>
                </ng-container>
                <ng-template #textAreaContent>
                  <textarea
                    class="service-chart-input px-2 mx-2 w-100"
                    [ngClass]="{
                      'collapsed-area': !showServiceDetail,
                      'mask-fade pointer-cursor': !showServiceDetail && parseInt(existingNote?.style?.height, 10) > 64,
                      'd-none': !chartEntry?.entryText
                    }"
                    [value]="chartEntry?.entryText ?? ''"
                    [readonly]="true"
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    [cdkAutosizeMinRows]="1"
                    #existingNote
                  ></textarea>
                </ng-template>
              </div>
              <textarea
                class="service-chart-input active px-2 pb-2 mx-2 w-100"
                [placeholder]="'Add a note'"
                [ngClass]="{
                  'collapsed-area': !showServiceDetail && chartEntry?.isLocked,
                  'empty-chart-note': !chartEntry?.entryText,
                  'mt-2': chartEntry?.entryText,
                  'd-none': chartEntry?.isLocked || !patientChartEditPolicySatisfied
                }"
                [value]="chartEntry?.draftText ?? ''"
                (keydown)="onTextareaKeyDown(); $event.stopPropagation()"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                [cdkAutosizeMinRows]="4"
                #newNote
              ></textarea>
            </div>
            <ng-container *ngFor="let photoDrawing of chartEntry?.photoDrawings">
              <img
                *ngIf="photoDrawing['delete'] !== true"
                class="img-thumb mr-2 mb-2"
                [src]="photoDrawing.photo.filePathThumb | safeResource"
                [alt]="photoDrawing.photo.imageName"
                (click)="openPhotoDrawing(photoDrawing)"
                role="button"
              />
            </ng-container>
          </div>
        </ng-container>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="d-flex grey-two-background">
    <div *ngIf="hasAudioConsultations()" class="grey-two-background px-3 medium">
      <strong>Consultation</strong>
      <div>
        <ng-container *ngFor="let patientNoteAudio of getPatientNoteAudioConsultations()">
          <button
            *ngIf="patientNoteAudio.transcript"
            type="button"
            title="View Consultation Transcript"
            class="btn btn-sm em-btn btn-clean mr-2 mb-2 btn-consultation"
            (click)="viewConsultTranscriptModal(patientNoteAudio.transcript)"
          >
            <i class="fas fa-edit"></i>
          </button>
          <button
            *ngIf="patientNoteAudio.audioBlobUrl"
            type="button"
            title="Play Consultation Audio"
            class="btn btn-sm em-btn btn-clean mr-3 mb-2 btn-consultation"
            (click)="viewConsultAudioModal(NoteAudioType.Consultation, patientNoteAudio.audioBlobUrl)"
          >
            <i class="fas fa-play-circle"></i>
          </button>
        </ng-container>
      </div>
    </div>
    <div *ngIf="hasAudioDictations()" class="grey-two-background px-3 medium">
      <strong>Dictation</strong>
      <div>
        <ng-container *ngFor="let patientNoteAudio of getPatientNoteAudioDictations()">
          <button
            type="button"
            title="Play Dictation Audio"
            class="btn btn-sm em-btn btn-clean mr-2 mb-2 btn-consultation"
            (click)="viewConsultAudioModal(NoteAudioType.Dictation, patientNoteAudio.audioBlobUrl)"
          >
            <i class="fas fa-play-circle"></i>
          </button>
        </ng-container>
      </div>
    </div>
  </div>
  <!-- Footer of sc entry -->
  <ng-container *appAuthGuard="patientChartEditPolicy">
    <div
      *ngIf="chartEntry && !chartEntry?.isLocked"
      class="service-chart-detail pl-3 pr-5 py-2 grey-two-background d-flex align-items-center"
    >
      <!-- Save, Sign, and Sign+Close buttons -->
      <div class="btn-group emr-btn-group note-btn draft-btn">
        <button
          type="button"
          title="Save Draft"
          [disabled]="!submitButtons.draft"
          class="btn btn-sm em-btn em-btn-green btn-clean mr-2 bigger save-draft-button chart-entry-button"
          (click)="updateChart(false); submitButtons.draft = false; submitButtons.save = true"
        >
          <i class="fab fa-firstdraft"></i>
        </button>
        <button
          type="button"
          title="Sign & Save"
          [attr.data-test-id]="'service-chart-sign-and-save'"
          [attr.data-test-value]="chartEntry?.patientNoteId"
          class="btn btn-sm em-btn em-btn-green btn-clean mr-2 bigger save-draft-button chart-entry-button"
          (click)="updateChart(true); submitButtons.save = false; submitButtons.draft = false"
          ngbDropdownItem
        >
          <i class="fas fa-signature"></i>
        </button>
        <button
          type="button"
          title="Sign, Save, & Exit"
          class="btn btn-sm em-btn em-btn-green btn-clean bigger save-draft-button chart-entry-button"
          (click)="signSaveExit()"
          ngbDropdownItem
        >
          <i class="fas fa-share-square"></i>
        </button>
      </div>
    </div>
  </ng-container>
</mat-expansion-panel>
